import LabDetail from "./LabDetail";

export default LabDetail;
